

// const BASE_URL = "https://staging.pteshstudios.com";

import "./NewEngineering.css";
import "./serviceEditor.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../../Images/newin.png';
import Aboutbg from '../../Images/new_install.jpeg';
import { ServiceEditModal, usePageEditor, resolveUrl } from "./serviceEditorShared";

const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];

const DEFAULT_DATA = {
  bannerImage: "",
  bgImage: "",
  title: "Our installation scope covers mechanical and electrical installation of field instruments, control valves, analyzers, junction boxes, impulse tubing, instrument air systems, and cable trays.",
  paragraphs: [
    "Jeyshawn Engineering Limited delivers comprehensive Installation and Instrumentation solutions for the oil & gas, energy, marine, and industrial sectors. We specialize in the installation, calibration, testing, commissioning, and maintenance of industrial equipment, instrumentation systems, and process control facilities designed to improve operational efficiency, safety, reliability, and productivity.",
    "Backed by a team of experienced engineers, instrumentation specialists, and technical professionals, we provide integrated solutions tailored to meet the specific operational and project requirements of our clients. Our services are executed in compliance with international engineering standards, industry regulations, and strict Health, Safety, and Environment (HSE) procedures.",
    "We provide installation services for mechanical, electrical, and process systems, including pipelines, pumps, valves, process skids, control panels, cable systems, and industrial equipment for both onshore and offshore facilities. Our expertise also covers instrumentation installation involving pressure, temperature, flow, and level instruments, control valves, gas detection systems, PLCs, SCADA systems, and industrial automation solutions that support accurate monitoring and efficient process control.",
    "Through innovation, technical excellence, and commitment to reliable delivery service, Jeyshawn Engineering Limited continues to provide dependable Installation and Instrumentation solutions that support industrial growth and operational success across diverse sectors.",
  ],
  sections: [],
};

export default function Installments() {
  const { pageData, loading, fetchErr, fetchData, modalOpen, setModalOpen, saving, handleSave, saveMsg } =
    usePageEditor("/api/installation-instrumentation", DEFAULT_DATA);

  const bannerImg = resolveUrl(pageData.bannerImage) || Avatar1;
  const bgImg     = resolveUrl(pageData.bgImage)     || Aboutbg;

  return (
    <>
      <button className="edit-fab" onClick={() => setModalOpen(true)} title="Edit page content">
        <span className="edit-fab__icon">✏️</span>
        <span className="edit-fab__label">Edit Page</span>
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr}<button onClick={fetchData}>Retry</button></div>}
      {modalOpen && (
        <ServiceEditModal data={pageData} onSave={handleSave} onClose={() => setModalOpen(false)} saving={saving} pageLabel="Installation & Instrumentation" />
      )}

      <div className="img_carrierins">
        <img src={bannerImg} alt="" />
      </div>

      <section className="service-detail" style={{ backgroundImage: `url(${bgImg})` }}>
        <div className="service-detail__layout">
          <div className="service-detail__content">
            <h2 className="service-detail__title">{pageData.title}</h2>
            <span className="service-detail__divider" />
            {pageData.paragraphs.map((p, i) => <p key={i} className="service-detail__intro">{p}</p>)}
            {pageData.sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => <li key={j} className="service-detail__list-item">{item}</li>)}
                </ul>
              </div>
            ))}
          </div>
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink key={s.href} to={s.href} className={({ isActive }) => `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`}>
                {s.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </section>
    </>
  );
}
